import { useEffect } from 'react';

export const useResizeObserver = (element: HTMLElement | undefined | null, callback: (el: HTMLElement) => void) => {
    useEffect(() => {
        if (!element || !('ResizeObserver' in window)) {
            return;
        }

        const resizeObserver = new window.ResizeObserver(() => {
            callback(element);
        });

        resizeObserver.observe(element);
        return () => {
            if (element) {
                resizeObserver.unobserve(element);
            }
        };
    }, [element]);
};
